import { useMutation, useQueryClient } from "@tanstack/react-query"
import { api } from "@/lib/api"
import { createTriggerToDto, TriggerDtoSchema, triggerFromDto } from "@/models/trigger"
import type { CreateTrigger, TriggerDto } from "@/models/trigger"

export function useCreateTrigger({ onSuccess }: { onSuccess?: () => void } = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (trigger: CreateTrigger) => {
      const dto = createTriggerToDto(trigger)
      const response = await api.post("/api/triggers", dto, TriggerDtoSchema)
      return triggerFromDto(response as TriggerDto)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["triggers"] })
      if (onSuccess) onSuccess()
    },
    onError: (error) => {
      console.error("Error creating trigger:", error)
    },
  })
}
